import React from "react";
import { Text } from "@fluentui/react-components";
import { CheckmarkFilled } from "@fluentui/react-icons/svg/checkmark";
import { useTranslation } from "react-i18next";
import { WizardStep } from "./BoardCreationWizard.ViewModel.types";
import "./onboarding-wizard.scss";

interface WizardStepperProps {
  currentStep: WizardStep;
  step1Label: string;
  step2Label: string;
  step3Label: string;
}

export const WizardStepper: React.FC<WizardStepperProps> = ({
  currentStep,
  step1Label,
  step2Label,
  step3Label,
}) => {
  const { t } = useTranslation();
  const step1Done = currentStep > 1;
  const step2Done = currentStep > 2;

  return (
    <nav aria-label={t("wizard.stepper.ariaLabel", "Setup progress")} className="wizard-stepper">
      <ol style={{ display: "contents" }}>
        <li className="wizard-stepper__step-item">
          <span
            className={`wizard-stepper__dot wizard-stepper__dot--${step1Done ? "done" : currentStep === 1 ? "active" : "todo"}`}
            aria-label={step1Done ? `Step 1 complete` : undefined}
            aria-current={currentStep === 1 ? "step" : undefined}
          >
            {step1Done ? <CheckmarkFilled aria-hidden /> : "1"}
          </span>
          <Text
            className={`wizard-stepper__label wizard-stepper__label--${currentStep === 1 ? "active" : "todo"}`}
          >
            {step1Label}
          </Text>
        </li>

        <li
          role="presentation"
          className={`wizard-stepper__connector wizard-stepper__connector--${step1Done ? "done" : "todo"}`}
        />

        <li className="wizard-stepper__step-item">
          <span
            className={`wizard-stepper__dot wizard-stepper__dot--${step2Done ? "done" : currentStep === 2 ? "active" : "todo"}`}
            aria-label={step2Done ? `Step 2 complete` : undefined}
            aria-current={currentStep === 2 ? "step" : undefined}
          >
            {step2Done ? <CheckmarkFilled aria-hidden /> : "2"}
          </span>
          <Text
            className={`wizard-stepper__label wizard-stepper__label--${currentStep === 2 ? "active" : "todo"}`}
          >
            {step2Label}
          </Text>
        </li>

        <li
          role="presentation"
          className="wizard-stepper__connector wizard-stepper__connector--todo"
        />

        <li className="wizard-stepper__step-item">
          <span
            className="wizard-stepper__dot wizard-stepper__dot--todo"
          >
            3
          </span>
          <Text className="wizard-stepper__label wizard-stepper__label--todo">
            {step3Label}
          </Text>
        </li>
      </ol>
    </nav>
  );
};
